<template>
  <div class="body">
      <div class="body_center">
        <div class="body_center_left">
          <div class="body_center_left_content">
            <article-item v-for="(item,index) in list" :key="index" :article="item"></article-item>
          </div>
        </div>
        <div class="body_center_right">
          <article-user></article-user>
          <recruit></recruit>
          <ad></ad>
          <download></download>
          <alliance-media></alliance-media>
          <helpful-links></helpful-links>
          <disclaimers></disclaimers>
          <about-us></about-us>
        </div>
      </div>
  </div>
</template>

<script>
import "@/assets/css/right.css"
import ArticleItem from '@/components/article/index'
import ArticleUser from '@/components/Right/articleUser'
import Recruit from '@/components/Right/recruit'
import Ad from '@/components/Right/ad'
import Download from '@/components/Right/download'
import AllianceMedia from '@/components/Right/allianceMedia'
import HelpfulLinks from '@/components/Right/helpfulLinks'
import Disclaimers from '@/components/Right/disclaimers'
import AboutUs from '@/components/Right/aboutUs'
import * as json from '@/assets/js/json'
export default {
  components: {
    ArticleItem,
    ArticleUser,
    Recruit,
    Ad,
    Download,
    AllianceMedia,
    HelpfulLinks,
    Disclaimers,
    AboutUs,
  },
  data () {
    return{
      page : 1,
      activeId: 58,
      list: [],
      areaState:false,
      countryList: [],
      cityList: [],
      country:null,
      city: null,
      nextPageState: true,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy(){
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch:{
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch(){
      const option = {
        'tagId': this.activeId,
        'current': 1
      }
      this.list = []
      for(let i=0;i<=2;i++){
        this.getListFun()
        this.page++
      }
    },
    getListFun(){
      const option = {
        'tagId': this.activeId,
        'current': this.page
      }
      json.post('/api/member/index/article_list', option).then((res) =>{
        let mergedArray= null
        if(res.data.data.list){
          let list = []
          res.data.data.list.forEach(item => {
            list.push(item.article)
          });
          mergedArray = this.list.concat(list)
        }else{
          mergedArray = this.list.concat(res.data.data.articles) 
        }
        this.nextPageState = true
        this.list = mergedArray
      })
    },
    selected (item) { // 选择栏目
      this.activeId = item.tagId
      if(this.activeId == '-1'){
        this.page = 1
      }else{
        this.page = 1
      }
      this.list = []
      for(let i=0;i<=2;i++){
        this.getListFun()
        this.page++
      }
    },
    toAreaFun(){
      this.areaStateFun()
    },
    areaStateFun(){
      if(this.areaState){
        this.areaState = false
      }else{
        json.post('/api/member/index/area/list').then((res) =>{
          this.countryList = res.data.data.areas
        })
        this.areaState = true
      }
    },
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop||document.body.scrollTop
      const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      const scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight
      if (scrollTop + windowHeight >= scrollHeight-5) {
        if(this.nextPageState){
          this.nextPageState = false
          this.page ++ 
          this.getListFun()
        }
      }
    },
  }
}
</script>

<style scoped>
.body{
  width: 1232px;
  margin: 0 auto;
  margin-top: 27px;
}
.body_center{
  width: 1234px;
  margin: 0 auto;
  box-sizing: border-box; 
}
.body_center_left{
  width: 813px;
  min-height: 100px;
  background: #FFFFFF;
}
.body_center_left_top{
  width: 730px;
  margin: 0 auto;
  padding-top: 33px;
  border-bottom: 1px solid #f5f5f5;
  position: relative;
}
.body_center_left_top_overflow_x{
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
}
.body_center_left_top_overflow_x::-webkit-scrollbar {
  height: 5px;
  background-color: #f5f5f5;
  border-radius: 5px;
}
.body_center_left_top_overflow_x::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 5px;
}
.body_center_left_top_item{
  flex-shrink: 0;
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
  display: inline-block;
  margin-left: 37px;
  cursor: pointer;
  white-space: nowrap;
}
.body_center_left_top_item img{
  width: 11px;
  height: 7px;
  margin-left: 10px;
}
.body_center_left_top_item:first-child{
  margin-left: 0;
}
.body_center_click{
  color: #FE512F;
}
.body_center_click .btn{
  width: 17px;
  height: 5px;
  background: #FE512F;
  border-radius: 3px;
  margin: 0 auto;
  margin-top: 15px;
}
.body_center_left_top_oter{
  width: 391px;
  background: #FFFFFF;
  box-shadow: 0px 3px 9px 0px rgba(0,0,0,0.1);
  border-radius: 8px;
  position: absolute;
  top: 66px;
  left: 350px;
  z-index: 999;
  padding: 10px 10px;
}
.body_center_left_top_oter div{
  width: 82px;
  height: 24px;
  background: #FFFFFF;
  border: 1px solid #EBEBEB;
  border-radius: 4px;
  display: inline-block;
  margin: 10px 5px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  cursor: pointer;
}
.body_center_left_top_oter div:hover{
  background: #FF6633;
  color: #FFFFFF;
}
.body_center_left_top_area{
  width: 280px;
  height: 110px;
  background: #FFFFFF;
  box-shadow: 0px 3px 9px 0px rgba(0,0,0,0.1);
  border-radius: 8px;
  position: absolute;
  top: 66px;
  left: 0;
  z-index: 998;
}
.body_center_left_top_area_top{
  padding-top: 16px;
  padding-bottom: 4px;
  width: 240px;
  height: 25px;
  border-bottom: 1px solid #EBEBEB;
  margin: 0 auto;
  line-height: 25px;
  position: relative;
}
.body_center_left_top_area_top div{
  display: inline-block;
}
.body_center_left_top_area_top_title{
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  position: absolute;
  left: 0px;
}
.body_center_left_top_area_top_input{
  width: 118px;
  height: 25px;
  position: absolute;
  right: 0px;
}
.body_center_left_top_area_top_input input{
  width: 78px;
  height: 12px;
  padding: 6px 21px 6px 17px;
  background: #FFFFFF;
  border: 1px solid #EBEBEB;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #CCCCCC;
  outline:none;
}
.body_center_left_top_area_top_input img{
  width: 14px;
  height: 14px;
  position: absolute;
  top: 7px;
  right: 7px;
}
.body_center_left_top_area_content{
  width: 240px;
  height: 25px;
  margin: 0 auto;
  margin-top: 17px;
  position: relative;
}
.body_center_left_top_area_content_country ,.body_center_left_top_area_content_city{
  width: 49%;
  display: inline-block;
  position: relative;
  position: absolute;
}
.body_center_left_top_area_content_country{
  left: 0px;
}
.body_center_left_top_area_content_city{
  right: 0px;
}
.body_center_left_top_area_country{
  width: 122px;
  height: 226px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.1);
  border-radius: 5px;
  position: absolute;
  top: 90px;
  left: 15px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  overflow-y: auto;
  overflow-x: hidden;
}
.body_center_left_top_area_country::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
  border-radius: 5px;
}
.body_center_left_top_area_country div{
  width: 97px;
  height: 30px;
  margin: 0 auto;
  line-height: 30px;
}
.body_center_left_top_area_city{
  width: 122px;
  height: 226px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.1);
  border-radius: 5px;
  position: absolute;
  top: 90px;
  left: 143px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  overflow-y: auto;
  overflow-x: hidden;
}
.body_center_left_top_area_city::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
  border-radius: 5px;
}
.body_center_left_top_area_city div{
  width: 97px;
  height: 30px;
  margin: 0 auto;
  line-height: 30px;
}
.body_center_left_content{
  width: 730px;
  margin: 0 auto;
  padding-bottom: 20px;
}



.body_center_left_content_article1{
  padding: 17px 0px;
  position: relative;
  border-bottom: 1px solid #E8E8E8;
  cursor: pointer;
}
.body_center_left_content_article1 img{
  width: 192px;
  height: 108px;
  background: #999999;
  border-radius: 10px;
}
.body_center_left_content_article1 .title{
  width: 522px;
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  position: absolute;
  top: 27px;
  left: 206px;
}
.body_center_left_content_article1 .msg_time{
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 12px;
  position: absolute;
  top: 103px;
  left: 209px;
}
.body_center_left_content_article1 .msg_time .time{
  margin-left: 23px;
}
.body_center_left_content_article2{
  padding: 21px 0px;
  position: relative;
  border-bottom: 1px solid #E8E8E8;
  cursor: pointer;
}
.body_center_left_content_article2 .title{
  width: 730px;
  height: 19px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 19px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.body_center_left_content_article2 .img_list{
  margin-top: 13px;
  text-align: center;
}
.body_center_left_content_article2 .img_list img{
  width: 238px;
  height: 134px;
  border-radius: 10px;
  display: inline-block;
}
.body_center_left_content_article2 .msg_time{
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 12px;
  margin-top: 18px;
  margin-left: 6px;
}
.body_center_left_content_article2 .msg_time .time{
  margin-left: 20px;
}
.body_center_left_content_ad{
  padding-top: 27px;
  padding-bottom: 21px;
  border-bottom: 1px solid #E8E8E8;
  cursor: pointer;
}
.body_center_left_content_ad .title{
  width: 730px;
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.body_center_left_content_ad .img_list{
  margin-top: 19px;
  font-size: 0;
}
.body_center_left_content_ad .img_list img{
  width: 514px;
  height: 234px;
  background: #CCFFFF;
  border-radius: 10px;
}
.body_center_left_content_ad .msg_time{
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 23px;
  margin-top: 20px;
}
.body_center_left_content_ad .msg_time .ad_icon{
  display: inline-block;
  width: 47px;
  height: 23px;
  background: #FFFFFF;
  border: 1px solid #DDDDDD;
  border-radius: 5px;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: #FF0000;
  line-height: 23px;
  margin-right: 9px;
}
.body_center_left_content_ad .msg_time .time{
  margin-left: 14px;
}
</style>